import React from 'react';
import { Box, Container, CircularProgress, Skeleton } from '@mui/material';

function SkeletonListItem() {
  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      p: 2,
      borderBlockEnd: '1px solid #e0e0e0',
      gap: '1rem',
    }}>
      <Skeleton variant="circular" width={40} height={40} />
      <Skeleton variant="text" width="60%" />
    </Box>
  );
}
export default function Loader({ variant = 'primary'}) {
  if (variant === 'course-list') {
    return (
      <Box>
        <SkeletonListItem />
        <SkeletonListItem />
        <SkeletonListItem />
        <SkeletonListItem />
        <SkeletonListItem />
        <SkeletonListItem />
        <SkeletonListItem />
        <SkeletonListItem />
        <SkeletonListItem />
        <SkeletonListItem />
      </Box>
    );
  }
  return (
    <Container sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '90vh',
    }}>
      <CircularProgress size="4rem" />
    </Container>
  );
}
